import { useCallback, useEffect, useRef, useState } from "react";

import { getCurrentGeolocation } from "../../service/geolocation";
import { GeolocationData } from "../../types/common";

export const useGeolocation = (): GeolocationData | undefined => {
  const [geolocation, setGeolocation] = useState<GeolocationData>();

  const geolocationInitialized = useRef(false);

  const loadGeolocation = useCallback(async () => {
    setGeolocation(await getCurrentGeolocation());
  }, [setGeolocation]);

  useEffect(() => {
    if (!geolocationInitialized.current) {
      geolocationInitialized.current = true;
      void loadGeolocation();
    }
  }, [geolocation, loadGeolocation]);

  return geolocation;
};
